/* eslint-disable import/no-unresolved */
import React from 'react';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import ScoresConfigTvs from 'src/components/leads/scoresConfigTvs/ScoresConfigTvs';
import { Backdrop, CircularProgress } from '@material-ui/core';
import { useStyles } from './styles';

const ScoreConfigPageTvs = (props) => {
  const {
    scores,
    onSubmitScore,
    onChangeScores,
    onSubmitProcess,
    loading,
  } = props;
  const classes = useStyles();

  return (
    <>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress />
      </Backdrop>
      <CardTitle title="Configuración de cálculos score - TVS" />

      <ScoresConfigTvs
        scores={scores}
        onSubmitScore={onSubmitScore}
        onChangeScores={onChangeScores}
        onSubmitProcess={onSubmitProcess}
      />
    </>
  );
};

export default ScoreConfigPageTvs;
